import { render, staticRenderFns } from "./EditionPublication.vue?vue&type=template&id=d3771884&scoped=true"
import script from "./EditionPublication.vue?vue&type=script&lang=js"
export * from "./EditionPublication.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d3771884",
  null
  
)

export default component.exports